import { contrastRatio } from '@yola/yola-palette-generator';
import highEmphasis from '../text/high-emphasis';
import utils from '../../common/utils';

const { reduceColorPointByRatio, increaseColorPointByRatio } = utils;
const firstCondition = (ratio) => ratio >= 3.5;
const secondCondition = (ratio) => ratio < 7;

const light = (params) => {
  const { targetColor, backgroundColor, targetColorPalette, whiteColor, blackColor } = params;
  const fallback = {
    rule: 'priceText.light',
    params,
  };
  if (!firstCondition(contrastRatio(backgroundColor, targetColor))) {
    return highEmphasis({ backgroundColor, whiteColor, blackColor });
  }

  let calculatedColor = increaseColorPointByRatio({
    targetColor,
    backgroundColor,
    targetColorPalette,
    condition: firstCondition,
    fallback,
  });

  if (secondCondition(contrastRatio(backgroundColor, calculatedColor))) {
    return calculatedColor;
  }

  calculatedColor = reduceColorPointByRatio({
    targetColor: calculatedColor,
    backgroundColor,
    targetColorPalette,
    condition: secondCondition,
    fallback,
  });

  return calculatedColor;
};

export default light;
